import { render, staticRenderFns } from "./FormCourse.vue?vue&type=template&id=cd1b2e98&"
import script from "./FormCourse.vue?vue&type=script&lang=js&"
export * from "./FormCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports